import { render, staticRenderFns } from "./register-success.vue?vue&type=template&id=39b2b1ed&scoped=true&"
import script from "./register-success.vue?vue&type=script&lang=js&"
export * from "./register-success.vue?vue&type=script&lang=js&"
import style0 from "./register-success.vue?vue&type=style&index=0&id=39b2b1ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b2b1ed",
  null
  
)

export default component.exports